import { render, staticRenderFns } from "./TagSetup.vue?vue&type=template&id=10608a24&scoped=true&"
import script from "./TagSetup.vue?vue&type=script&lang=ts&"
export * from "./TagSetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10608a24",
  null
  
)

export default component.exports